<template>
  <div id="app">
    <div id="pc-header">
      <transition name="fade">
        <div v-if="scrollY" id="pc-logo"><router-link to="/">
          <img src="./assets/estate_icon/pc/logo_black.png">
        </router-link></div>
      </transition>
      <div id="nav">
        <li><router-link to="/">TOP</router-link></li>
        <li><router-link to="/company">COMPANY</router-link>
          <ul>
            <li><router-link to="/company#message">メッセージ</router-link></li>
            <li><router-link to="/company#business">事業紹介</router-link></li>
            <li><router-link to="/company#summary">概要</router-link></li>
            <li><router-link to="/company#history">沿革</router-link></li>
            <li><router-link to="/company#office">オフィス風景</router-link></li>
            <li><router-link to="/company#branchoffice">支社</router-link></li>
          </ul>
        </li>
        <li><router-link to="/team">TEAM</router-link></li>
        <li><router-link to="/gallery">GALLERY</router-link></li>
        <!-- <li><router-link to="/news_list">NEWS</router-link></li> -->
        <li><router-link to="/recruit">RECRUITMENT</router-link></li>
        <li><router-link to="/contact">CONTACT</router-link></li>
      </div>
      <div id="pc-search">
        <img class="language" src="./assets/estate_icon/pc/language@2x.png">
        <div class="JP"><router-link to="/">JP</router-link></div>
        <div class="CN"><a href="http://cn.jpestateone.com/">CN</a></div>
        <div class="search">
          <SearchButton imgSrc="search-icon@2x.png" />
        </div>
      </div>
    </div>

    <div class="sp-header">
      <div class="sp-header-inner">
        <div class="sp-logo"><router-link to="/">
          <img src="./assets/estate_icon/pc/logo_black.png">
        </router-link></div>
        <SpHeaderButton />
      </div>
    </div>

    <div id="main-body">
      <transition name="fade" mode="out-in">
          <router-view :key="$route.params.id"/>
      </transition>
    </div>
    <foot msg="Copyright"/>
  </div>
</template>

<script>
import foot from '@/components/foot.vue'
import SearchButton from '@/components/SearchButton.vue'
import SpHeaderButton from '@/components/SpHeaderButton.vue'
export default {
  name: 'App',
  components: {
    foot,
    SearchButton,
    SpHeaderButton
  },
  data () {
    return {
      scrollY: true
    }
  },
  methods: {
    handleScroll (event) {
      // Any code to be executed when the window is scrolled
      // this.scrollY = window.scrollY > window.innerHeight
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss">
$width-pc-min: 600px;
$width-md-min: 801px;
$width-sm-max: 800px;
$width-sm-min: 551px;
$width-xs-max: 550px;
$width-pc-content: 1160px;
body { margin: 0; }
#app {
  font-family: "SF Pro Text","Myriad Set Pro","SF Pro Icons","Apple Legacy Chevron","Helvetica Neue","Helvetica","Arial",sans-serif,"SF Pro JP","SF Pro Text","SF Pro Icons","Hiragino Kaku Gothic Pro","ヒラギノ角ゴ Pro W3","メイリオ","Meiryo","ＭＳ Ｐゴシック","Helvetica Neue","Helvetica","Arial",sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
// pc header setting
#pc-header{
  background-color: #fff;
  top: 0px;
  position: fixed;
  width: 100%;
  height: 8vh;
  text-align: left;
  overflow: visible;
  display: flex;
  justify-content: space-between;
  align-items: center;

  z-index: 10;
  @media (max-width: 1400px) {
    display: none;
  }
}
#pc-logo{
  display: flex;
  margin-left: 3.6vh;
  margin-top: -.2vh;
  img{
    width: auto;
    height: 4vh;
  }
}
#nav {
  overflow: visible;
  display: flex;
  height: 100%;
  li{
    display: flex;
    align-items: center;
    height: 100%;
    a {
      font-weight: bold;
      text-decoration: none;
      position: relative;
      font-size: 2.3vh;
      margin-left: 3.2vh;
      margin-right: 3.2vh;
      color: #3B3B3B;
      transition: color .3s ease;
      -webkit-transition: color .3s ease;
      background-color: #fff;
      z-index: 15;
      &.router-link-exact-active {
        color: #D0AF1F;
      }
    }
    a:hover{
      color: #D0AF1F;
    }
    a::after {
      border-bottom: solid 2px #D0AF1F;
      bottom: 0;
      display: block;
      content: "";
      transition: all .3s ease;
      -webkit-transition: all .3s ease;
      width: 0;
    }
    a:hover::after {
      width: 100%;
    }

    ul{
      position: absolute;
      top: -350px;
      z-index: 11;
      transition: all .3s ease;
      -webkit-transition: all .3s ease;
      padding: 0;
      padding-top: 3vh;
      margin: 0;
      background-color: rgba(255,255,255,0.7);
      width: 14vw;
    }
    &:hover ul{
      top: 8vh;
    }
    ul li{
      display: block;
      margin: 0;
      padding: 0;
    }
    ul li:hover{
    }
    ul li a{
      color: #3B3B3B;
      background-color: rgba(255,255,255,0);
      font-size: .9vw;
    }
    ul li a::after {
      border-bottom: solid 0px #D0AF1F;
    }
  }
}
#pc-search{
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2vh;
  font-family: sans-serif;
  font-weight: 400;
  margin-right: 4vh;

  .language{
    display: flex;
    align-items: center;
    height: 3vh;
    margin-right: 2.6vh;
  }
  .JP{
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #737B7B;
    color: #F8F8F8;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
    text-decoration: none;
    width: 4.6vh;
    height: 4vh;
    a, a:visited{
      text-decoration: none;
      color: #F8F8F8;
    }
  }
  .CN{
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #3B3B3B;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
    width: 4.6vh;
    height: 4vh;
    a, a:visited{
      text-decoration: none;
      color: #D0AF1F;
    }
  }
  .search{
    display: flex;
    align-items: center;
    margin-left: 2.6vh;
    height: 3vh;
  }
}
#main-body{
}
// sp header setting
.sp-header{
  position: fixed;
  top: 0px;
  z-index: 30;
  display: none;

  @media (max-width: 1400px) {
    display: block;
  }
}

.sp-header-inner{
  background-color: #fff;
  top: 0px;
  width: 100vw;
  height: 50px;
  text-align: left;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .sp-logo{
    display: flex;
    margin-left: 18px;
    img{
      width: auto;
      height: 30px;
    }
  }
}

// transition setting

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}
</style>
